import { useState } from 'react';
import './ToastDesignShowcaseMob.scss';

const VARIANTS = [
  { id: 'solid-brand', label: 'Solid brand bar (bottom)' },
  { id: 'card-subtle', label: 'Subtle card (bottom)' },
  { id: 'pill-floating', label: 'Floating pill (center-low)' },
  { id: 'outline-light', label: 'Outline only (bottom)' },
  { id: 'shadow-strong', label: 'Strong shadow card' },
  { id: 'accent-left', label: 'Accent strip left' },
  { id: 'glass', label: 'Glassmorphism' },
  { id: 'minimal', label: 'Ultra-minimal' },
  { id: 'icon-left', label: 'Icon left, text wrap' },
  { id: 'full-width', label: 'Full-width banner' },
];

export function ToastDesignShowcaseMob() {
  const [activeId, setActiveId] = useState('solid-brand');

  return (
    <div className="toast-showcase-mob">
      <header className="toast-showcase-mob__header">
        <h1>Toast design options</h1>
        <p>Tap a style to preview how the toast could look on the mobile product pages.</p>
      </header>

      <section className="toast-showcase-mob__variants">
        {VARIANTS.map((v) => (
          <button
            key={v.id}
            type="button"
            className={`toast-showcase-mob__variant-chip ${activeId === v.id ? 'is-active' : ''}`}
            onClick={() => setActiveId(v.id)}
          >
            {v.label}
          </button>
        ))}
      </section>

      <section className="toast-showcase-mob__device-frame">
        <div className="toast-showcase-mob__screen">
          <div className="toast-showcase-mob__mock-card">
            <div className="img-skeleton" />
            <div className="meta">
              <div className="brand">Al Madr Originals</div>
              <div className="title">Soft touch cotton tee</div>
              <div className="price">
                <span className="price-main">₹799</span>
                <span className="price-mrp">₹1,299</span>
                <span className="price-off">(40% OFF)</span>
              </div>
            </div>
          </div>

          {/* Preview toast */}
          <div className={`toast-preview toast-preview--${activeId}`}>
            <div className="toast-preview__icon" aria-hidden>
              ✓
            </div>
            <div className="toast-preview__body">
              <div className="toast-preview__title">Added to cart</div>
              <div className="toast-preview__subtitle">Soft touch cotton tee · Size M</div>
            </div>
            <button type="button" className="toast-preview__action">
              VIEW
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

